<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <!-- <size-select id="size-select" class="right-menu-item hover-effect" /> -->

        <version-select id="version-select" class="right-menu-item hover-effect" />
      </template>

      <!-- <el-tooltip content="提交问题、需求或体验反馈" placement="bottom">
        <el-badge value="新" class="feedback-entry">
          <el-button
            class="feedback-entry__button"
            size="mini"
            icon="el-icon-chat-dot-square"
            @click="openFeedback"
          >
            反馈
          </el-button>
        </el-badge>
      </el-tooltip> -->
      <notification class="right-menu-item hover-effect" />
      <div class="avatar-container right-menu-item hover-effect">
        <div class="avatar-wrapper">
          <el-button type="text" size="medium" @click="toSelectAccountSet()">
            {{ currentAccountSet ? currentAccountSet.alias : "" }}
            <i class="el-icon-caret-bottom" />
          </el-button>
        </div>
      </div>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span v-if="user">
            <span v-if="user.cashier_name">: {{ user.cashier_name }}</span>
            <i class="el-icon-caret-bottom" />
          </span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span style="display: block" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <AccountSet ref="dialogAccountSet" :data="accountSetList" :show-dialog.sync="dialogVisible" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
// import SizeSelect from '@/components/SizeSelect';
import VersionSelect from '@/components/VersionSelect';
import Search from '@/components/HeaderSearch';
import Notification from '@/components/Notification';
import { findAccountSets, getCurrentAccountSet, removeCurrentAccountSet } from '@/api/accountSet';
import AccountSet from './AccountSet';
import { sharedSSEManager } from '@/services/sse/sharedSSEManager';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    VersionSelect,
    Search,
    Notification,
    AccountSet
  },
  data () {
    return {
      accountSetList: [],
      dialogVisible: false
    }
  },
  computed: {
    currentAccountSet () {
      return getCurrentAccountSet();
    },
    ...mapGetters(['sidebar', 'avatar', 'device', 'user', 'accountSet'])
  },
  watch: {
    accountSet: {
      handler (val) {
        if (!val || !val.code) {
          removeCurrentAccountSet();
          this.dialogVisible = true;
          this.disconnectSSE();
        } else {
          this.connectSSE();
          this.dialogVisible = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  async created () {
    try {
      var { data } = await findAccountSets({ deleted: 0 });
      const accountSetList = this.normalizeAccountSetList(data);
      this.accountSetList = accountSetList;
      this.$store.commit('app/SET_ACCOUNT_SET_LIST', accountSetList);
    } catch (err) {
      console.log(err)
    }
  },
  beforeDestroy () {
    this.disconnectSSE();
  },
  methods: {
    toSelectAccountSet () {
      this.$refs.dialogAccountSet.openDialog();
    },
    normalizeAccountSetList (data) {
      if (Array.isArray(data)) {
        return data;
      }
      return data && Array.isArray(data.accountSetList) ? data.accountSetList : [];
    },
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar');
    },
    openFeedback () {
      this.$router.push('/feedback');
    },
    async logout () {
      this.disconnectSSE();
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    connectSSE () {
      sharedSSEManager.start({
        maxRetries: 5,
        maxRetryDelay: 30000
      });
    },
    disconnectSSE () {
      sharedSSEManager.stop('navbar-disconnect');
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .feedback-entry {
      margin: 0 8px;
      line-height: 50px;
      vertical-align: top;

      ::v-deep .el-badge__content {
        top: 11px;
        right: 2px;
        height: 15px;
        line-height: 15px;
        padding: 0 4px;
        border: none;
      }
    }

    .feedback-entry__button {
      padding: 6px 10px;
      color: #262729;
      border-color: #dcdfe6;
      background: #fff;

      &:hover,
      &:focus {
        color: #262729;
        border-color: #bfc2c7;
        background: #f5f7fa;
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 19px;
          font-size: 12px;
        }

        .el-button {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
